// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  padding-top: 70px;
  padding-bottom: 30px;
}

.panel-group .panel + .panel {
  margin-top: 10px;
}

/* \\f142 is ellipsis-v */
/* \\202F is thin unbreakable space */
.fa.fa-grip:before {
  content: "\\f142 \\f142";
}

/*fa-grip-large : <i class="fa fa-grip-large fa-rotate-90"></i>*/
.fa.fa-grip-large:before {
  content: "\\f142 \\f142 \\f142 \\f142";
}

.panel-title .chevron:after {
  content: "\\f078";
}

.panel-title .collapsed .chevron:after {
  content: "\\f054";
}

.xlist.ng-enter {
  /*
  -webkit-transition: 0.4s ease-in all;
    -moz-transition: 0.4s ease-in all;
    -ms-transition: 0.4s ease-in all;
    -o-transition: 0.4s ease-in all;
  */
  transition: 0.4s ease-in all;
  opacity: 0;
}

.xlist.ng-enter.ng-enter-active {
  opacity: 1;
}

.xlist.ng-leave {
  transition: 0.4s ease-out all;
  opacity: 1;
}

.xlist.ng-leave.ng-leave-active {
  opacity: 0;
}

.drop-box {
  border: 2px dashed #ddd;
  margin: 5px;
}

.dragover {
  background: #f8f8f8;
  border: 5px dashed darkorange;
  position: relative;
}

.dragOverlay {
  display: none;
}

.dragover .dragOverlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  text-align: center;
  color: white;
  background: rgb(0, 0, 0);
  opacity: 0.3;
  /* all other browsers*/
  filter: alpha(opacity=30);
  /* for IE5-7*/
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=30)";
  /* for IE8*/
  z-index: 2;
}

.dragInner {
  font-size: 25px;
  position: absolute;
  top: 40%;
  left: 44%;
}

.list-group {
  margin-bottom: 0px;
}

/* ng-sortable css file */
.as-sortable-item,
.as-sortable-placeholder {
  display: block;
}

.as-sortable-item {
  touch-action: none;
  -webkit-touch-callout: none;
}

.as-sortable-item-handle {
  cursor: move;
  cursor: -moz-grab;
}

.as-sortable-drag {
  position: absolute;
  pointer-events: none;
  z-index: 9999;
}

.as-sortable-hidden {
  display: none !important;
}

.as-sortable-un-selectable {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.as-sortable-item,
.as-sortable-placeholder {
  min-height: 20px;
  margin: 1px 2px 5px 1px;
  border-radius: 10px;
}

.as-sortable-item {
  border: solid 1px darkgrey;
  background-color: #fff;
}

.as-sortable-placeholder {
  border: 1px dashed darkgrey;
  box-sizing: border-box;
  background-color: #dbdbdb;
}

.as-sortable-drag {
  opacity: 0.8;
}

html,
body {
  height: 100%;
}

.container {
  display: flex;
  height: 100%;
  flex-direction: row;
  justify-contents: center;
  align-items: center;
  text-align: center;
}

.check-ok {
  /*flex: 1; */
  display: inline-block;
  width: 30px;
  animation: pop-out 0.5s cubic-bezier(0.87, -0.41, 0.19, 1.44) forwards;
}

.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash 0.9s cubic-bezier(0.65, 0, 0.45, 1) forwards 0.65s;
}

@keyframes dash {
  from {
    stroke-dashoffset: 1000;
  }
  to {
    stroke-dashoffset: 0;
  }
}
@keyframes pop-out {
  from {
    transform: scale(0.23);
  }
  to {
    transform: scale(1);
  }
}
.inputfile {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 90%;
}

.inputfile-button {
  display: inline-block;
  background-color: #305a8e;
  width: 30px;
  height: 30px;
  margin-right: 10px;
  border-radius: 50%;
  margin-left: 10px;
  position: relative;
  border: 2px solid #305a8e;
  transition: all 0.25s ease;
  -moz-transition: all 0.25s ease;
  -webkit-transition: all 0.25s ease;
}
.inputfile-button:hover {
  background-color: white;
  color: white;
  transition: all 0.25s ease;
  -moz-transition: all 0.25s ease;
  -webkit-transition: all 0.25s ease;
}
.inputfile-button:hover::before {
  color: #305a8e;
}

.inputfile-button::before {
  font-weight: bold;
  position: absolute;
  content: "+";
  font-size: 23px;
  color: white;
  top: -10%;
  left: 27%;
  cursor: pointer;
}

.row {
  display: flex;
  width: 100%;
  margin-bottom: 14px;
}
.row .column {
  width: 50%;
  position: relative;
}
.row .column ::placeholder {
  color: black;
}
.row .column label {
  display: block;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 7px;
  color: transparent;
}
.row .column .input-field {
  display: flex;
  align-items: center;
  border: 1px solid #305a8e;
  width: 90%;
  height: 40px;
  background: transparent;
  border-radius: 16px;
}
.row .column .input-field input[type=text] {
  border: none;
  width: 90%;
  box-sizing: border-box;
  margin-left: 3px;
}
.row .column .input-field input[type=date] {
  border: none;
  width: 98%;
  box-sizing: border-box;
  margin-left: 3px;
}
.row .column .input-field input[type=text]:focus {
  outline: none;
}
.row .column .input-field input[type=date]:focus {
  outline: none;
}
.row .column .input-field .select-img {
  margin-right: 10px;
}
.row .column .input-field select {
  appearance: none;
  background-color: transparent;
  border: none;
  padding-left: 3px;
  width: 100%;
  margin: 0;
  line-height: inherit;
  outline: none;
  cursor: pointer;
}
.row .column .input-field .edit {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: #305a8e;
  display: flex;
  cursor: pointer;
}
.row .column .input-field .edit img {
  vertical-align: middle;
}
.inputAsSenderValidating {
  padding: 5px 15px;
}

.invalid-reason-input {
  width: 100%;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}

::ng-deep .list-group-item {
  width: 800px !important;
}

::ng-deep .form-row.ng-untouched.ng-pristine.ng-invalid {
  width: 800px !important;
}

::ng-deep .card {
  left: 50px;
  top: 60px;
  width: 800px !important;
}

::ng-deep .invalid {
  margin-top: 80px !important;
  width: 800px;
  margin-left: 50px;
  margin-bottom: 30px;
}

::ng-deep .text-center.ng-star-inserted {
  margin-bottom: 30px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+document-request/upload-documents/upload-documents.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,iBAAA;EACA,oBAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AAAA,wBAAA;AACA,oCAAA;AAEA;EACE,sBAAA;AAEF;;AAAA,gEAAA;AAEA;EACE,kCAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE;;;;;GAAA;EAMA,4BAAA;EACA,UAAA;AAEF;;AACA;EACE,UAAA;AAEF;;AACA;EACE,6BAAA;EACA,UAAA;AAEF;;AACA;EACE,UAAA;AAEF;;AACA;EACE,uBAAA;EACA,WAAA;AAEF;;AACA;EACE,mBAAA;EACA,6BAAA;EACA,kBAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,wBAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;EACA,iEAAA;EACA,WAAA;EACA,UAAA;AAEF;;AACA;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AAAA,yBAAA;AAEA;;EAEE,cAAA;AAEF;;AACA;EAEE,kBAAA;EACA,2BAAA;AAEF;;AACA;EACE,YAAA;EAEA,iBAAA;AAEF;;AACA;EACE,kBAAA;EACA,oBAAA;EACA,aAAA;AAEF;;AACA;EACE,wBAAA;AAEF;;AACA;EACE,2BAAA;EACA,yBAAA;EAIA,iBAAA;AAEF;;AACA;;EAEE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAEF;;AACA;EACE,0BAAA;EACA,sBAAA;AAEF;;AACA;EACE,2BAAA;EACA,sBAAA;EACA,yBAAA;AAEF;;AACA;EACE,YAAA;AAEF;;AACA;;EAEE,YAAA;AAEF;;AAAA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;AAGF;;AAAA;EACE,YAAA;EACA,qBAAA;EACA,WAAA;EACA,sEAAA;AAGF;;AADA;EACE,sBAAA;EACA,uBAAA;EACA,kEAAA;AAIF;;AADA;EACE;IACE,uBAAA;EAIF;EAFA;IACE,oBAAA;EAIF;AACF;AADA;EACE;IACE,sBAAA;EAGF;EADA;IACE,mBAAA;EAGF;AACF;AAAA;EACE,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AAEF;;AACA;EACE,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,0BAAA;EACA,+BAAA;EACA,kCAAA;AAEF;AAAE;EACE,uBAAA;EACA,YAAA;EACA,0BAAA;EACA,+BAAA;EACA,kCAAA;AAEJ;AAAI;EACE,cAAA;AAEN;;AAGA;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAAF;AACE;EAIE,UAAA;EACA,kBAAA;AAFJ;AAFI;EACE,YAAA;AAIN;AAAI;EACE,cAAA;EAEA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EAEA,kBAAA;AAAN;AAGI;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AADN;AAEM;EACE,YAAA;EACA,UAAA;EACA,sBAAA;EACA,gBAAA;AAAR;AAGM;EACE,YAAA;EACA,UAAA;EACA,sBAAA;EACA,gBAAA;AADR;AAGM;EACE,aAAA;AADR;AAIM;EACE,aAAA;AAFR;AAKM;EACE,kBAAA;AAHR;AAMM;EACE,gBAAA;EACA,6BAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,SAAA;EACA,oBAAA;EACA,aAAA;EACA,eAAA;AAJR;AAOM;EAEE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AANR;AAQQ;EACE,sBAAA;AANV;AAiBA;EACE,iBAAA;AAfF;;AAkBA;EACE,WAAA;AAfF;;AAiBA;EACE,kCAAA;AAdF;;AAgBA;EACE,uBAAA;AAbF;;AAeA;EACE,uBAAA;AAZF;;AAcA;EACE,UAAA;EACA,SAAA;EACA,uBAAA;AAXF;;AAaA;EACE,2BAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAVF;;AAYA;EACE,8BAAA;AATF","sourcesContent":["body {\r\n  padding-top: 70px;\r\n  padding-bottom: 30px;\r\n}\r\n\r\n.panel-group .panel + .panel {\r\n  margin-top: 10px;\r\n}\r\n/* \\f142 is ellipsis-v */\r\n/* \\202F is thin unbreakable space */\r\n\r\n.fa.fa-grip:before {\r\n  content: \"\\f142 \\202F \\f142\";\r\n}\r\n/*fa-grip-large : <i class=\"fa fa-grip-large fa-rotate-90\"></i>*/\r\n\r\n.fa.fa-grip-large:before {\r\n  content: \"\\f142 \\202F \\f142 \\202F \\f142 \\202F \\f142\";\r\n}\r\n\r\n.panel-title .chevron:after {\r\n  content: \"\\f078\";\r\n}\r\n\r\n.panel-title .collapsed .chevron:after {\r\n  content: \"\\f054\";\r\n}\r\n\r\n.xlist.ng-enter {\r\n  /*\r\n-webkit-transition: 0.4s ease-in all;\r\n  -moz-transition: 0.4s ease-in all;\r\n  -ms-transition: 0.4s ease-in all;\r\n  -o-transition: 0.4s ease-in all;\r\n*/\r\n  transition: 0.4s ease-in all;\r\n  opacity: 0;\r\n}\r\n\r\n.xlist.ng-enter.ng-enter-active {\r\n  opacity: 1;\r\n}\r\n\r\n.xlist.ng-leave {\r\n  transition: 0.4s ease-out all;\r\n  opacity: 1;\r\n}\r\n\r\n.xlist.ng-leave.ng-leave-active {\r\n  opacity: 0;\r\n}\r\n\r\n.drop-box {\r\n  border: 2px dashed #ddd;\r\n  margin: 5px;\r\n}\r\n\r\n.dragover {\r\n  background: #f8f8f8;\r\n  border: 5px dashed darkorange;\r\n  position: relative;\r\n}\r\n\r\n.dragOverlay {\r\n  display: none;\r\n}\r\n\r\n.dragover .dragOverlay {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  display: block;\r\n  text-align: center;\r\n  color: white;\r\n  background: rgb(0, 0, 0);\r\n  opacity: 0.3;\r\n  /* all other browsers*/\r\n  filter: alpha(opacity=30);\r\n  /* for IE5-7*/\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";\r\n  /* for IE8*/\r\n  z-index: 2;\r\n}\r\n\r\n.dragInner {\r\n  font-size: 25px;\r\n  position: absolute;\r\n  top: 40%;\r\n  left: 44%;\r\n}\r\n\r\n.list-group {\r\n  margin-bottom: 0px;\r\n}\r\n/* ng-sortable css file */\r\n\r\n.as-sortable-item,\r\n.as-sortable-placeholder {\r\n  display: block;\r\n}\r\n\r\n.as-sortable-item {\r\n  -ms-touch-action: none;\r\n  touch-action: none;\r\n  -webkit-touch-callout: none;\r\n}\r\n\r\n.as-sortable-item-handle {\r\n  cursor: move;\r\n  cursor: -webkit-grab;\r\n  cursor: -moz-grab;\r\n}\r\n\r\n.as-sortable-drag {\r\n  position: absolute;\r\n  pointer-events: none;\r\n  z-index: 9999;\r\n}\r\n\r\n.as-sortable-hidden {\r\n  display: none !important;\r\n}\r\n\r\n.as-sortable-un-selectable {\r\n  -webkit-touch-callout: none;\r\n  -webkit-user-select: none;\r\n  -khtml-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\n.as-sortable-item,\r\n.as-sortable-placeholder {\r\n  min-height: 20px;\r\n  margin: 1px 2px 5px 1px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.as-sortable-item {\r\n  border: solid 1px darkgrey;\r\n  background-color: #fff;\r\n}\r\n\r\n.as-sortable-placeholder {\r\n  border: 1px dashed darkgrey;\r\n  box-sizing: border-box;\r\n  background-color: #dbdbdb;\r\n}\r\n\r\n.as-sortable-drag {\r\n  opacity: 0.8;\r\n}\r\n\r\nhtml,\r\nbody {\r\n  height: 100%;\r\n}\r\n.container {\r\n  display: flex;\r\n  height: 100%;\r\n  flex-direction: row;\r\n  justify-contents: center;\r\n  align-items: center;\r\n  text-align: center;\r\n}\r\n\r\n.check-ok {\r\n  /*flex: 1; */\r\n  display: inline-block;\r\n  width: 30px;\r\n  animation: pop-out 0.5s cubic-bezier(0.87, -0.41, 0.19, 1.44) forwards;\r\n}\r\n.path {\r\n  stroke-dasharray: 1000;\r\n  stroke-dashoffset: 1000;\r\n  animation: dash 0.9s cubic-bezier(0.65, 0, 0.45, 1) forwards 0.65s;\r\n}\r\n\r\n@keyframes dash {\r\n  from {\r\n    stroke-dashoffset: 1000;\r\n  }\r\n  to {\r\n    stroke-dashoffset: 0;\r\n  }\r\n}\r\n\r\n@keyframes pop-out {\r\n  from {\r\n    transform: scale(0.23);\r\n  }\r\n  to {\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n.inputfile {\r\n  opacity: 0;\r\n  overflow: hidden;\r\n  position: absolute;\r\n  width: 90%;\r\n}\r\n\r\n.inputfile-button {\r\n  display: inline-block;\r\n  background-color: #305a8e;\r\n  width: 30px;\r\n  height: 30px;\r\n  margin-right: 10px;\r\n  border-radius: 50%;\r\n  margin-left: 10px;\r\n  position: relative;\r\n  border: 2px solid #305a8e;\r\n  transition: all 0.25s ease;\r\n  -moz-transition: all 0.25s ease;\r\n  -webkit-transition: all 0.25s ease;\r\n\r\n  &:hover {\r\n    background-color: white;\r\n    color: white;\r\n    transition: all 0.25s ease;\r\n    -moz-transition: all 0.25s ease;\r\n    -webkit-transition: all 0.25s ease;\r\n\r\n    &::before {\r\n      color: #305a8e;\r\n    }\r\n  }\r\n}\r\n\r\n.inputfile-button::before {\r\n  font-weight: bold;\r\n  position: absolute;\r\n  content: \"+\";\r\n  font-size: 23px;\r\n  color: white;\r\n  top: -10%;\r\n  left: 27%;\r\n  cursor: pointer;\r\n}\r\n\r\n.row {\r\n  display: flex;\r\n  width: 100%;\r\n  margin-bottom: 14px;\r\n  .column {\r\n    ::placeholder {\r\n      color: black;\r\n    }\r\n    width: 50%;\r\n    position: relative;\r\n    label {\r\n      display: block;\r\n      //font-family: DM Sans;\r\n      font-style: normal;\r\n      font-weight: bold;\r\n      font-size: 16px;\r\n      margin-bottom: 7px;\r\n      // color: #717C88;\r\n      color: transparent;\r\n    }\r\n\r\n    .input-field {\r\n      display: flex;\r\n      align-items: center;\r\n      border: 1px solid #305a8e;\r\n      width: 90%;\r\n      height: 40px;\r\n      background: transparent;\r\n      border-radius: 16px;\r\n      input[type=\"text\"] {\r\n        border: none;\r\n        width: 90%;\r\n        box-sizing: border-box;\r\n        margin-left: 3px;\r\n      }\r\n\r\n      input[type=\"date\"] {\r\n        border: none;\r\n        width: 98%;\r\n        box-sizing: border-box;\r\n        margin-left: 3px;\r\n      }\r\n      input[type=\"text\"]:focus {\r\n        outline: none;\r\n      }\r\n\r\n      input[type=\"date\"]:focus {\r\n        outline: none;\r\n      }\r\n\r\n      .select-img {\r\n        margin-right: 10px;\r\n      }\r\n\r\n      select {\r\n        appearance: none;\r\n        background-color: transparent;\r\n        border: none;\r\n        padding-left: 3px;\r\n        width: 100%;\r\n        margin: 0;\r\n        line-height: inherit;\r\n        outline: none;\r\n        cursor: pointer;\r\n      }\r\n\r\n      .edit {\r\n        // font-family: DM Sans;\r\n        font-style: normal;\r\n        font-weight: 500;\r\n        font-size: 12px;\r\n        color: #305a8e;\r\n        display: flex;\r\n        cursor: pointer;\r\n\r\n        img {\r\n          vertical-align: middle;\r\n        }\r\n\r\n        span {\r\n          //  margin-left: 3px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.inputAsSenderValidating {\r\n  padding: 5px 15px;\r\n}\r\n\r\n.invalid-reason-input {\r\n  width: 100%;\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n}\r\n::ng-deep .list-group-item {\r\n  width: 800px !important;\r\n}\r\n::ng-deep .form-row.ng-untouched.ng-pristine.ng-invalid {\r\n  width: 800px !important;\r\n}\r\n::ng-deep .card {\r\n  left: 50px;\r\n  top: 60px;\r\n  width: 800px !important;\r\n}\r\n::ng-deep .invalid {\r\n  margin-top: 80px !important;\r\n  width: 800px;\r\n  margin-left: 50px;\r\n  margin-bottom: 30px;\r\n}\r\n::ng-deep .text-center.ng-star-inserted{\r\n  margin-bottom: 30px !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
